import React from 'react'
import { Carousel } from '../carousel/Carousel'
import { Writer } from './Writer'
import { Title } from '../archive/Title'
import { useAllWritersQuery } from '../../hooks/useAllWritersQuery'
import { Link } from '../global'

import './writers.scss'

/**
 * Represents a list of writers or bloggers within your application.
 *
 * @param {string} props.title - The title for the list (optional, default is an empty string).
 * @param {string} props.url - The URL to link to (optional, default is an empty string).
 * @returns {JSX.Element} A React component rendering a list of writers.
 */
export const Writers = ({ title = '', url = '', authorName }) => {
  const data = useAllWritersQuery()

  const writers = data.map(
    (writer, index) =>
      writer.name !== authorName && (
        <Link href={writer.link} key={index}>
          <Writer writer={writer} isBlogger />
        </Link>
      ),
  )

  return (
    <div>
      {title && (
        <div className="title-link-container innerContainer">
          <Title text={title} />
          {url && <Link to={url}>Gå till {title}</Link>}
        </div>
      )}
      <div className="writers-container">
        <Carousel
          settings={{
            arrows: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  swipeToSlide: true,
                },
              },
            ],
          }}
          data={writers}
          gradiant={{ show: true }}
        />
      </div>
      <br></br>
    </div>
  )
}
